export { default } from './useAmplitudeLog';
